import { useState, useEffect } from "react";
import { verifyPayment } from "../services/api";

export const usePaymentVerify = () => {
  const [status, setStatus] = useState("verifying"); // verifying | success | failed | cancelled
  const [details, setDetails] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    const verify = async () => {
      const params = new URLSearchParams(window.location.search);
      const tx_ref = params.get("tx_ref");
      const transaction_id = params.get("transaction_id");
      const flw_status = params.get("status");

      if (!tx_ref || !transaction_id) {
        setStatus("failed");
        setError("Missing payment reference. Please contact support.");
        return;
      }

      try {
        const result = await verifyPayment({ tx_ref, transaction_id, status: flw_status });
        if (result.success) {
          setStatus("success");
          setDetails(result.data);
        } else if (result.status === "cancelled") {
          setStatus("cancelled");
        } else {
          setStatus("failed");
          setError(result.message || "Payment could not be verified.");
        }
      } catch (err) {
        setStatus("failed");
        setError(err.message || "Verification error. Please contact support.");
      }
    };

    verify();
  }, []);

  return { status, details, error };
};
